export const siteSettings = {
  name: "Magnate Markets",
  link: "https://themagnatexmarkets.com",
  email: "support@themagnatexmarkets.com",
  appLink: "https://app.themagnatexmarkets.com",
};
